// METIS Hub wording — namespace "common" (en), 893 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/i18n.js + js/core.js + js/charts.js).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const common: Record<string, string> = {
  "app.name": "METIS Hub",
  "app.tagline": "Company AI usage records",
  "app.skip": "Skip to content",
  "app.docTitle": "{page} · METIS Hub",
  "nav.main": "Main menu",
  "nav.bottom": "Bottom menu",
  "nav.home": "Home",
  "nav.logs": "Activity",
  "nav.stats": "Insights",
  "nav.people": "People",
  "nav.connect": "Connect",
  "nav.glossary": "Glossary",
  "nav.settings": "My records",
  "nav.admin": "Admin",
  "nav.admin.roles": "Roles & permissions",
  "nav.admin.policy": "Recording policy",
  "nav.admin.audit": "Access & change log",
  "nav.admin.system": "Collection status",
  "nav.login": "Sign in",
  "nav.more": "More",
  "nav.moreTitle": "More menus",
  "nav.home.desc": "How much and how did I use AI this week?",
  "nav.logs.desc": "When, with which AI, and what did I do?",
  "nav.stats.desc": "When, how much, and for what is AI used?",
  "nav.people.desc": "How are teams and people using AI?",
  "nav.connect.desc": "Are my AI tools sending records properly?",
  "nav.glossary.desc": "What do the words on screen mean?",
  "nav.settings.desc": "What is recorded, and who viewed it?",
  "nav.admin.roles.desc": "Who can see what?",
  "nav.admin.policy.desc": "What does the company keep, and for how long?",
  "nav.admin.audit.desc": "Who viewed or changed what, and when?",
  "nav.admin.system.desc": "Are records coming in completely?",
  "rail.collapse": "Collapse menu",
  "rail.expand": "Expand menu",
  "rail.help.title": "Reading the numbers",
  "rail.help.body": "See what usage (tokens), estimated cost and AI active time mean, in plain words.",
  "rail.help.link": "Open glossary",
  "header.search": "Search",
  "header.searchLabel": "Search screens, people, terms and records (Ctrl K)",
  "header.lang": "Language",
  "header.lang.ko": "한국어",
  "header.lang.en": "English",
  "header.theme.toDark": "Switch to dark theme",
  "header.theme.toLight": "Switch to light theme",
  "header.bell": "Notifications",
  "header.bellUnread": "Notifications, {n} unread",
  "header.user": "Account menu",
  "menu.settings": "My records & settings",
  "menu.theme": "Theme",
  "menu.lang": "Language",
  "menu.logout": "Sign out",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.system": "System",
  "theme.changed": "Switched to {theme} theme",
  "role.admin": "Admin",
  "role.manager": "Manager",
  "role.member": "Member",
  "role.auditor": "Content reviewer",
  "role.ops": "Operations",
  "role.custom_teamlead": "Team lead (content)",
  "role.admin.desc": "Sees everyone’s records and manages roles, permissions, policy and integrations. Other people’s text goes through the fixed access flow (reason, re-sign-in, per-conversation grant).",
  "role.manager.desc": "Sees usage and per-person totals for the teams they manage (by team at the time of the record). Teammates’ text is off by default.",
  "role.member.desc": "Sees all of their own records and text, and manages recording level, consent and tool connections.",
  "role.auditor.desc": "Only opens question and answer text (no admin functions), each time with a reason, re-sign-in and a per-conversation grant.",
  "role.ops.desc": "Runs collection, integrations and deletion requests. Cannot see question or answer text.",
  "role.kind.base": "Base role",
  "role.kind.preset": "Preset",
  "role.kind.custom": "Custom",
  "scope.me": "Me",
  "scope.team": "My team",
  "scope.all": "Everyone",
  "scopeVal.off": "Off",
  "scopeVal.self": "Self",
  "scopeVal.team": "Team",
  "scopeVal.all": "All",
  "period.label": "Period",
  "period.today": "Today",
  "period.7d": "7 days",
  "period.30d": "30 days",
  "period.90d": "90 days",
  "period.custom": "Custom",
  "period.long.today": "Today",
  "period.long.7d": "Last 7 days",
  "period.long.30d": "Last 30 days",
  "period.long.90d": "Last 90 days",
  "period.long.custom": "Custom range",
  "period.from": "From",
  "period.to": "To",
  "period.customTitle": "Pick a date range",
  "period.invalid": "The start date is after the end date.",
  "period.range": "{from} – {to}",
  "period.asOf": "As of {time}",
  "period.days": "{n|day|days}",
  "source.cli.claude_code": "Claude Code",
  "source.cli.codex": "Codex",
  "source.api.anthropic": "Anthropic API",
  "source.api.openai": "OpenAI API",
  "source.other": "Other",
  "path.cli": "CLI tool",
  "path.api": "API key call",
  "path.cli.long": "CLI tools (Claude Code · Codex)",
  "path.api.long": "API key calls",
  "provider.anthropic": "Anthropic",
  "provider.openai": "OpenAI",
  "auth.subscription": "Subscription login",
  "auth.api_key": "Billed to API key",
  "auth.unknown": "Not confirmed",
  "authMode.label": "Billing method",
  "authMode.subscription": "Subscription login",
  "authMode.api_key": "API key",
  "authMode.unknown": "Not confirmed",
  "authMode.not_applicable": "Not applicable",
  "authMode.estimate": "Estimate",
  "authMode.estimateNote": "For Claude Code, the billing method is an estimate: it’s the last value confirmed on each device. Codex confirms it on every request.",
  "authMode.cliOnly": "Only CLI tools have a billing method. API key calls are grouped as “Not applicable”.",
  "mode.direct": "Send straight to server",
  "mode.helper": "Via PC helper",
  "status.ok": "OK",
  "status.quiet": "Quiet for a while",
  "status.down": "Not connected",
  "status.active": "Active",
  "status.grace": "Grace period",
  "status.revoked": "Revoked",
  "status.online": "Collection server connected",
  "status.offline": "Collection server disconnected",
  "status.success": "Succeeded",
  "status.failed": "Failed",
  "status.retry": "Retried",
  "status.refused": "Refused by policy",
  "status.warn": "Needs a look",
  "status.danger": "Problem",
  "status.info": "Info",
  "status.idle": "Idle",
  "decision.auto": "Allowed automatically (settings)",
  "decision.user_accept": "Allowed by user",
  "decision.user_reject": "Rejected by user",
  "decision.config_reject": "Rejected by settings",
  "level.label": "Recording level",
  "level.1": "① Basic info",
  "level.2": "② + Question text",
  "level.3": "③ + AI answer text",
  "level.4": "④ + Work details",
  "level.short.1": "① Basic info",
  "level.short.2": "② Question text",
  "level.short.3": "③ AI answer text",
  "level.short.4": "④ Work details",
  "level.desc.1": "Only time, tool, AI model, usage, duration and success.",
  "level.desc.2": "Basic info plus the question text.",
  "level.desc.3": "Question text plus the AI answer text.",
  "level.desc.4": "Answer text plus commands, file paths and changes.",
  "missing.label": "No record",
  "missing.not_sent": "not sent by CLI settings",
  "missing.level": "off at this recording level",
  "missing.consent": "not agreed yet",
  "missing.na": "not applicable to this usage method",
  "missing.codex_active": "Codex doesn’t send AI active time",
  "missing.codex_loc": "Codex does not send line counts",
  "missing.api_time": "API key calls have no AI active time",
  "missing.api_files": "API key calls have no file work",
  "missing.claude_reasoning": "Claude does not report reasoning separately",
  "missing.unofficial": "unofficial value not received",
  "missing.small_group": "hidden: fewer than 3 people",
  "missing.perm": "permission needed",
  "missing.not_parsed": "support being checked",
  "missing.no_prev": "no previous-period record",
  "missing.no_data": "no records in this period",
  "missing.zero": "0 (confirmed)",
  "common.cancel": "Cancel",
  "common.ok": "OK",
  "common.apply": "Apply",
  "common.reset": "Reset to default",
  "common.options": "Options",
  "common.less": "Show less",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.copyFail": "Couldn’t copy. Select the text and copy it yourself.",
  "common.retry": "Try again",
  "common.goHome": "Go home",
  "common.viewTable": "View as table",
  "common.viewChart": "View as chart",
  "common.loading": "Loading",
  "common.updated": "Updated {time}",
  "common.basis": "Based on {n|record|records}",
  "common.source": "Source",
  "common.on": "On",
  "common.off": "Off",
  "common.all": "All",
  "common.none": "None",
  "common.yes": "Yes",
  "common.no": "No",
  "common.details": "Details",
  "common.dismiss": "Dismiss",
  "common.search": "Search",
  "common.noResult": "No results",
  "common.tryOther": "Try another word.",
  "common.estimated": "Estimated",
  "common.unofficial": "Unofficial",
  "common.truncated": "Truncated",
  "common.count": "{n|record|records}",
  "common.people": "{n|person|people}",
  "common.items": "{n|item|items}",
  "common.times": "{n|time|times}",
  "common.lines": "{n|line|lines}",
  "common.open": "Open",
  "common.new": "New",
  "common.me": "Me",
  "common.you": "(you)",
  "common.sample": "Sample",
  "common.and": "·",
  "state.notReady.title": "This screen is coming soon",
  "state.notReady.desc": "This screen isn’t registered yet ({route}). It appears here once its screen file is added.",
  "state.notFound.page": "Screen not found",
  "state.notFound.title": "We can’t find this screen",
  "state.notFound.desc": "Check the address ({route}). You can move with the menu or Search (Ctrl K).",
  "state.noAccess.title": "You don’t have access to this screen",
  "state.noAccess.desc": "Your current role ({role}) can’t view it. Ask an admin if you need access.",
  "state.error.title": "Couldn’t draw this screen",
  "state.error.desc": "Try again in a moment. If it keeps happening, tell an admin.",
  "state.emptyTitle": "No records yet",
  "state.emptyDesc": "Connect a CLI tool or an API key and your usage will show up here.",
  "state.loadError": "Couldn’t load",
  "palette.title": "Search",
  "palette.placeholder": "Search screens, people, terms, records",
  "palette.group.screens": "Screens",
  "palette.group.people": "People",
  "palette.group.terms": "Terms",
  "palette.group.logs": "Records",
  "palette.hint.move": "Move",
  "palette.hint.open": "Open",
  "palette.hint.close": "Close",
  "palette.empty": "No results for ‘{q}’",
  "palette.emptyHint": "Korean initial consonants (e.g. ㅌㅋ) also work.",
  "bell.title": "Notifications",
  "bell.readAll": "Mark all read",
  "bell.empty": "You’re all caught up",
  "bell.allRead": "Marked all notifications as read",
  "footer.last": "Last record {rel}",
  "footer.tz": "Stored in UTC, shown in Korea time",
  "access.title": "Tell us why you need to see this text",
  "access.kicker": "Fixed access flow",
  "access.desc": "Conversation #{no} belongs to {name}. Your access is shown to them and kept in the access & change log, and you can view only this conversation for {min} minutes.",
  "access.reasonLabel": "Reason (10+ characters)",
  "access.reasonPh": "e.g. Checking per security review request (add the review number)",
  "access.confirm": "Record reason and view",
  "access.tooShort": "Please write at least 10 characters.",
  "access.granted": "Access recorded and shown to the owner. You can view this conversation for {min} minutes.",
  "access.needReason": "The text is stored · leave a reason to view it",
  "access.request": "Enter a reason to view",
  "access.left": "{min} min left",
  "access.ownerNotice": "It appears in the owner’s “Who viewed my records” list.",
  "opt.title": "View options",
  "opt.button": "Options",
  "opt.buttonLabel": "View options for {title}",
  "opt.period": "Period",
  "opt.groupBy": "Group by",
  "opt.chartType": "Chart type",
  "opt.metrics": "Metrics",
  "opt.metricsMax": "Choose up to {n}",
  "opt.topN": "Top N",
  "opt.compare": "Compare with previous period",
  "opt.compareMode": "Comparison",
  "opt.compare.prev": "Same length before",
  "opt.compare.avg": "Previous average line",
  "opt.toggles": "Display",
  "opt.unit": "Unit",
  "opt.unit.raw": "tokens",
  "opt.unit.1e4": "10K tokens",
  "opt.unit.1e6": "1M tokens",
  "opt.changed": "Some options differ from the default",
  "opt.applied": "View options applied",
  "chartType.bar": "Bars",
  "chartType.line": "Lines",
  "chartType.area": "Area",
  "chartType.donut": "Donut",
  "chartType.table": "Table",
  "groupBy.none": "No grouping",
  "groupBy.source": "Tool",
  "groupBy.tool": "AI company",
  "groupBy.path": "How used",
  "groupBy.model": "AI model",
  "groupBy.user": "Person",
  "groupBy.team": "Team",
  "groupBy.project": "Project",
  "groupBy.weekday": "Weekday",
  "groupBy.hour": "Hour of day",
  "groupBy.fileExt": "File type",
  "groupBy.toolName": "AI action",
  "bucket.hour": "Hour",
  "bucket.day": "Day",
  "bucket.week": "Week",
  "bucket.month": "Month",
  "metric.prompts": "Questions",
  "metric.sessions": "Conversations",
  "metric.requests": "AI requests",
  "metric.tokens": "Usage (tokens)",
  "metric.tokens.in": "Newly read",
  "metric.tokens.out": "Written by AI",
  "metric.tokens.cacheRead": "Read from cache",
  "metric.tokens.cacheWrite": "Saved to cache",
  "metric.tokens.reasoning": "Thinking (included)",
  "metric.costUsd": "Estimated cost",
  "metric.activeMs": "AI active time",
  "metric.durationMs": "Time the chat was open",
  "metric.files.read": "Files opened by AI",
  "metric.files.edited": "Files edited by AI",
  "metric.lines.added": "Lines added",
  "metric.lines.removed": "Lines removed",
  "metric.tools": "Actions by AI",
  "metric.commands": "Commands run",
  "metric.errors": "Errors",
  "metric.rejects": "Rejections",
  "metric.latency.p50": "Wait time (typical)",
  "metric.latency.p95": "Wait time (slow)",
  "unit.tokens": "tokens",
  "unit.count": "",
  "unit.people": "people",
  "unit.lines": "lines",
  "unit.files": "files",
  "unit.times": "times",
  "costKind.cli_estimate": "CLI tool estimate",
  "costKind.unofficial": "Unofficial",
  "costKind.gateway_price": "Price table",
  "costKind.org_bill": "Org billing",
  "cost.notBill": "Not a bill",
  "cost.noSum": "Calculated differently, so never added together",
  "delta.up": "{p} more than the previous period",
  "delta.down": "{p} less than the previous period",
  "delta.flat": "About the same as the previous period",
  "delta.new": "None in the previous period",
  "delta.vsPrev": "vs previous period",
  "perm.audit.view": "View access & change log",
  "perm.stats.export.desc": "Export insights and lists as CSV or JSON.",
  "perm.connections.manage.desc": "Manage CLI and PC connections and connection tokens.",
  "diff.fold": "Show {n} unchanged lines",
  "diff.unfolded": "Showing {n} unchanged lines",
  "diff.copy": "Copy changes in {path}",
  "diff.truncated": "Only part of the value was sent",
  "diff.added": "{n|line|lines} added",
  "diff.removed": "{n|line|lines} removed",
  "diff.del": "Removed line",
  "diff.add": "Added line",
  "diff.empty": "No changes",
  "code.lang.powershell": "PowerShell",
  "code.lang.bash": "Bash",
  "code.lang.json": "JSON",
  "code.lang.javascript": "JavaScript",
  "code.lang.diff": "Patch",
  "code.lang.text": "Text",
  "code.lines": "{n|line|lines}",
  "code.more": "Show all · {n|line|lines}",
  "code.less": "Collapse",
  "code.open": "Open larger view",
  "code.copy": "Copy content",
  "code.title": "Full command or input",
  "code.body": "{lang} content",
  "fileTree.label": "Files opened or edited by AI",
  "fileTree.read": "Opened",
  "fileTree.edit": "Edited",
  "fileTree.create": "Created",
  "fileTree.estimated": "Estimated",
  "fileTree.estimatedTip": "Path guessed from a shell command. Not guaranteed to be complete.",
  "fileTree.folder": "{name} folder",
  "tl.prompt": "Question",
  "tl.request": "AI call",
  "tl.tool": "AI action",
  "tl.command": "Command",
  "tl.answer": "AI answer",
  "tl.error": "Error",
  "tl.decision": "Allow / reject",
  "tl.system": "Environment",
  "logcat.tool": "Tool runs",
  "logcat.command": "Commands",
  "logcat.decision": "Allowed / rejected",
  "logcat.error": "Errors & retries",
  "logcat.system": "Environment",
  "logcat.filterLabel": "Record types",
  "logcat.empty": "No records of the selected types",
  "json.expand": "Expand",
  "json.collapse": "Collapse",
  "json.items": "{n|item|items}",
  "redact.label": "Hidden: {kind}",
  "redact.email": "email",
  "redact.phone": "phone number",
  "redact.secret": "secret",
  "redact.card": "card number",
  "redact.rrn": "resident ID",
  "redact.path": "secret file path",
  "redact.name": "name",
  "wizard.label": "Progress",
  "wizard.step": "Step {n}",
  "wizard.doneStep": "{label} (done)",
  "permCell.locked": "Required permission — can’t be changed",
  "permCell.changed": "Set {perm} for {role} to {value}",
  "permCell.hint": "Each click cycles Off → Self → Team → All.",
  "perm.matrixLabel": "Permission table by role",
  "table.rowOpen": "Open {title}",
  "table.region": "{label} table",
  "table.cols.more": "Show {n|more column|more columns}",
  "table.cols.less": "Show fewer columns",
  "chart.avg": "Avg",
  "chart.prev": "Previous",
  "chart.total": "Total",
  "chart.other": "Other",
  "chart.less": "Less",
  "chart.more": "More",
  "chart.keys": "Use the arrow keys to move between items",
  "chart.noData": "No records in this period",
  "chart.summary": "{title}. {n|item|items}, largest {max} ({at}).",
  "chart.summaryEmpty": "{title}. No records.",
  "chart.hidden": "Hidden: fewer than 3 people in this view",
  "chart.legendToggle": "Show or hide {label}",
  "chart.isolate": "Show only {label}",
  "chart.target": "Target",
  "chart.share": "Share",
  "kpi.vsPrev": "vs previous period",
  "nav.admin.cost": "Cost policy",
  "nav.admin.cost.desc": "How is cost calculated and managed?",
  "nav.settings.page": "My records & settings",
  "role.manager.long": "Manager (team lead)",
  "role.content_reviewer": "Content reviewer",
  "role.log_reviewer": "Log reviewer",
  "role.stats_viewer": "Stats viewer",
  "role.delegated_admin": "Delegated admin",
  "role.content_reviewer.desc": "Only opens question and answer text (no admin functions). Each view needs a reason, re-sign-in and a per-conversation grant, and shows up in the owner’s “Who viewed my records”.",
  "role.log_reviewer.desc": "Reads only the access & change log and basic info. Can’t open text or export names or text; runs the monthly review.",
  "role.stats_viewer.desc": "Sees anonymous aggregates only. Can’t open conversation lists; teams under 3 people are merged.",
  "role.delegated_admin.desc": "Manages people and roles inside assigned teams, never beyond their own permissions.",
  "role.custom_teamlead.desc": "A custom role copied from Manager that adds teammates’ question and answer text (team), with two-person approval.",
  "role.kind.system": "Base role (read-only)",
  "role.copyToEdit": "Copy it to edit",
  "permCat.usage": "Usage",
  "permCat.records": "Record list & people",
  "permCat.content": "Question & answer text",
  "permCat.work": "Work details",
  "permCat.export": "Export",
  "permCat.admin": "Administration",
  "permCat.view": "Usage",
  "permCat.usage.desc": "See numbers such as questions, usage, cost and insights.",
  "permCat.records.desc": "See record lists, people, real names and individual details.",
  "permCat.content.desc": "See question and AI answer text. Other people’s text goes through the fixed access flow.",
  "permCat.work.desc": "See files, changes, commands, tool output and technical details.",
  "permCat.export.desc": "Export aggregates, rows, names and text. Default is pseudonymous without text.",
  "permCat.admin.desc": "Manage people, teams, roles, policy, integrations, deletion and logs.",
  "perm.usage.view": "View usage",
  "perm.usage.view.desc": "See questions, usage, time and AI models on Home and Insights.",
  "perm.cost.view": "View cost",
  "perm.cost.view.desc": "See CLI tool estimates, price-table costs and org billing.",
  "perm.stats.view": "View insights",
  "perm.stats.view.desc": "See the Insights screen and the team tab of People.",
  "perm.logs.list": "View record list",
  "perm.logs.list.desc": "See the activity list and basic info in record details. No text inside.",
  "perm.people.view": "View people & teams",
  "perm.people.view.desc": "See the people tab, person comparisons and team connection status.",
  "perm.people.identity": "View real names",
  "perm.people.identity.desc": "See real names. Without it, names show as pseudonyms (User #1F3A).",
  "perm.people.individual": "View individual details",
  "perm.people.individual.desc": "Open person details. Each view is logged and shown to the person.",
  "perm.logs.prompt": "View question text",
  "perm.logs.prompt.desc": "See question text. Other people’s text needs a reason, re-sign-in and a per-conversation grant.",
  "perm.logs.answer": "View AI answer text",
  "perm.logs.answer.desc": "See AI answer text. Other people’s text goes through the fixed access flow.",
  "perm.logs.files": "View files",
  "perm.logs.files.desc": "See files opened or edited by AI. Labels right away, full paths after the access flow.",
  "perm.logs.diff": "View changes",
  "perm.logs.diff.desc": "See changed lines (added and removed).",
  "perm.logs.commands": "View full commands",
  "perm.logs.commands.desc": "See full commands the AI ran. Program names are basic info.",
  "perm.logs.tool_output": "View tool output",
  "perm.logs.tool_output.desc": "See parts of file contents and command output.",
  "perm.logs.raw": "View technical details",
  "perm.logs.raw.desc": "See raw data filtered by the other record permissions.",
  "perm.export.aggregate": "Export aggregates",
  "perm.export.aggregate.desc": "Export insight aggregates as CSV or JSON.",
  "perm.export.rows": "Export rows (pseudonymous)",
  "perm.export.rows.desc": "Export record rows with pseudonyms.",
  "perm.export.identity": "Export with names",
  "perm.export.identity.desc": "Export with real names; needs a reason and a pledge, and is shown to the people.",
  "perm.export.content": "Export with text",
  "perm.export.content.desc": "Export with question and answer text; needs a reason and a pledge, and is shown to the people.",
  "perm.people.manage": "Manage users",
  "perm.people.manage.desc": "Add, invite, suspend and restore users; issue temporary passwords.",
  "perm.teams.manage": "Manage teams",
  "perm.teams.manage.desc": "Create, move and archive teams and assign managers.",
  "perm.roles.manage": "Manage roles",
  "perm.roles.manage.desc": "All scope edits role definitions; team scope only grants and revokes roles.",
  "perm.policy.manage": "Manage recording policy",
  "perm.policy.manage.desc": "Set the company ceiling, masking rules, retention, access-flow values and the price table.",
  "perm.notice.manage": "Manage notices",
  "perm.notice.manage.desc": "Edit and publish notices and pledges.",
  "perm.integrations.manage": "Manage integrations",
  "perm.integrations.manage.desc": "Gateway and org-report integrations; register and rotate AI company keys.",
  "perm.keys.view": "View API key registry",
  "perm.keys.view.desc": "See key last 4 characters, owner and status.",
  "perm.devices.revoke_any": "Disconnect others",
  "perm.devices.revoke_any.desc": "Revoke other people’s collect tokens and devices.",
  "perm.budget.manage": "Manage budgets",
  "perm.budget.manage.desc": "(Optional module) Set budgets and limits per team.",
  "perm.deletion.process": "Process deletion requests",
  "perm.deletion.process.desc": "Delete, hold or reject deletion requests.",
  "perm.legal_hold.manage": "Manage legal holds",
  "perm.legal_hold.manage.desc": "Place and lift legal holds.",
  "perm.access.approve": "Second approval",
  "perm.access.approve.desc": "Approve permission changes and investigation cases as the second person.",
  "perm.audit.view.desc": "See who viewed or changed what, and when.",
  "perm.audit.verify": "Tamper check",
  "perm.audit.verify.desc": "Check the log’s hash chain against external anchors.",
  "perm.retention.manage": "Manage retention jobs",
  "perm.retention.manage.desc": "Run jobs that delete expired records and see the results.",
  "perm.glossary.edit": "Edit glossary",
  "perm.glossary.edit.desc": "Edit term explanations, examples and external links.",
  "perm.system.view": "View collection status",
  "perm.system.view.desc": "See counts per collection path, gaps and version support.",
  "perm.stats.export": "Export aggregates",
  "perm.connections.manage": "Disconnect others",
  "perm.flowNote": "* For other people’s records, the fixed access flow applies (reason, re-sign-in, per-conversation grant)",
  "perm.dualNote": "Raising text, name or export permissions needs two-person approval",
  "scope.label": "View scope",
  "scope.allTeams": "All teams",
  "scope.teamFilter": "Team",
  "scope.teamFilterLabel": "Pick a team within Everyone",
  "method.label": "How used",
  "method.all": "All",
  "method.cli": "CLI tool",
  "method.api": "API key call",
  "method.other": "Other",
  "surface.label": "Where it ran",
  "surface.terminal": "Terminal",
  "surface.ide": "Editor extension",
  "surface.desktop": "Desktop app",
  "surface.sdk": "SDK",
  "surface.automation": "Automation",
  "surface.unknown": "Unknown",
  "surface.not_applicable": "Not applicable",
  "effort.label": "Thinking depth",
  "effort.low": "Low",
  "effort.medium": "Medium",
  "effort.high": "High",
  "effort.unknown": "Not confirmed",
  "effort.not_applicable": "Not applicable",
  "actor.user": "Person",
  "actor.config": "Settings rule",
  "actor.hook": "Policy hook",
  "actor.none": "Not recorded",
  "decisionKind.allow": "Allowed",
  "decisionKind.reject": "Rejected",
  "errorKind.rate_limit": "Rate limit (429)",
  "errorKind.server": "Server error (5xx)",
  "errorKind.refusal": "Refused by policy",
  "errorKind.tool_fail": "Tool failure",
  "actionKind.read": "Read file",
  "actionKind.edit": "Edit file",
  "actionKind.write": "Write file",
  "actionKind.command": "Run command",
  "actionKind.search": "Search text",
  "actionKind.find": "Find files",
  "actionKind.web": "Web fetch & search",
  "actionKind.delegate": "Delegate subtask",
  "actionKind.plan": "Plan & to-dos",
  "actionKind.skill": "Run skill",
  "actionKind.mcp": "External tool (MCP)",
  "actionKind.other": "Other action",
  "groupBy.method": "How used",
  "groupBy.surface": "Where it ran",
  "groupBy.effort": "Thinking depth",
  "groupBy.teamAtEvent": "Team (at the time)",
  "groupBy.teamNow": "Team (now)",
  "groupBy.person": "Person",
  "groupBy.folder": "Folder",
  "groupBy.actor": "Decided by",
  "groupBy.decision": "Allowed / rejected",
  "groupBy.errorKind": "Error type",
  "groupBy.costKind": "Cost type",
  "groupBy.actionKind": "Action type",
  "groupBy.apiKey": "API key",
  "groupBy.provider": "AI company",
  "metric.questionsLen": "Question length",
  "metric.slashCommands": "Slash commands",
  "metric.cacheReuseRatio": "Cache reuse ratio",
  "metric.filesByExt": "Files by extension",
  "metric.folders": "Files by folder",
  "metric.patches": "Patches",
  "metric.firstToken": "Time to first text",
  "metric.effortShare": "Thinking depth mix",
  "metric.decisionsBy": "Allowed / rejected (by whom)",
  "metric.errorKinds": "Error types",
  "metric.gatewayCalls": "Gateway calls",
  "metric.orgReport": "Org report",
  "metric.costByKind": "Cost by type",
  "agg.folderHidden": "Folder",
  "agg.rootFolder": "(top folder)",
  "agg.blocked.permission": "Comparing by person needs the people & teams permission.",
  "agg.blocked.no_person_metric": "This metric is never compared by person (not for evaluating work or performance).",
  "conn.ok": "Connected",
  "conn.quiet": "Quiet for a while",
  "conn.down": "Not connected",
  "conn.off": "Recording off",
  "conn.revoked": "Disconnected",
  "conn.problem": "Error",
  "conn.rule": "Connected = last received within 4 h · Quiet = 4 h to 3 days · Not connected = over 3 days",
  "status.connected": "Connected",
  "consent.item.basic": "Basic info",
  "consent.item.prompt": "Question text",
  "consent.item.answer": "AI answer text",
  "consent.item.work_detail": "Work details",
  "consent.item.tool_output": "Tool output",
  "consent.item.server_upload": "Send to company server",
  "consent.capOff": "Off at the company ceiling",
  "consent.helperOnly": "Only for PC helper users",
  "consent.reconsent": "Please agree to notice {v} again",
  "consent.paused": "Recording paused until {until}",
  "reasonCat.label": "Reason category",
  "reasonCat.security_incident": "Security incident",
  "reasonCat.user_support": "User support request",
  "reasonCat.outage": "Outage investigation",
  "reasonCat.other": "Other",
  "auditKind.login": "Sign-in",
  "auditKind.permission": "Permission change",
  "auditKind.policy": "Policy change",
  "auditKind.content_view": "Text view",
  "auditKind.person_view": "Individual view",
  "auditKind.export": "Export",
  "auditKind.consent": "Consent change",
  "auditKind.deletion": "Deletion",
  "auditKind.legal_hold": "Legal hold",
  "auditKind.key_rotation": "Key rotation",
  "auditKind.glossary": "Glossary change",
  "auditKind.other": "Other",
  "result.success": "Succeeded",
  "result.denied": "Denied",
  "result.failed": "Failed",
  "result.pending": "Pending",
  "support.level.verified": "Verified in tests",
  "support.level.source": "Checked in source",
  "support.level.doc": "Documented",
  "support.status.conditional": "Conditional",
  "support.status.unofficial": "Unofficial",
  "support.status.unsupported": "Not supported",
  "support.status.na": "Not applicable",
  "support.status.checking": "Being checked",
  "support.tool.claude_code": "Claude Code",
  "support.tool.codex": "Codex",
  "support.tool.anthropic_api": "Anthropic API",
  "support.tool.openai_api": "OpenAI API",
  "support.item.prompt": "Question text",
  "support.item.answer": "AI answer text",
  "support.item.tool_detail": "Tool details",
  "support.item.active_time": "AI active time",
  "support.item.lines": "Lines of code",
  "support.item.reasoning": "Thinking",
  "support.item.cache_write": "Saved to cache",
  "support.item.cost": "Cost",
  "value.none": "No record",
  "value.partial": "Partial",
  "value.zero": "0 (confirmed)",
  "value.goSupport": "See the support table",
  "value.goFix": "See how to fix",
  "reason.consent_before": "not agreed yet",
  "reason.paused": "paused",
  "reason.level_off": "off at this recording level",
  "reason.cli_not_sent": "not sent by CLI settings",
  "reason.tool_not_sent": "this tool doesn’t send it",
  "reason.not_applicable": "not applicable to this usage method",
  "reason.version_checking": "support being checked",
  "reason.old_version": "older than the supported version",
  "reason.expired": "deleted after retention",
  "reason.gap": "server didn’t receive this period",
  "reason.permission": "permission needed",
  "reason.small_group": "hidden: fewer than 3 people",
  "reason.verifying": "being verified",
  "reason.consent_before.help": "Records from before you agreed (or before you re-agreed to a changed notice) aren’t stored.",
  "reason.paused.help": "You paused recording during this time.",
  "reason.level_off.help": "This item isn’t in your recording level (or the company ceiling).",
  "reason.cli_not_sent.help": "The level allows it, but the CLI settings on the PC don’t send it. Get the settings again.",
  "reason.tool_not_sent.help": "The tool never sends this value.",
  "reason.not_applicable.help": "This usage method has no such value.",
  "reason.version_checking.help": "A new version not yet checked in the support table.",
  "reason.old_version.help": "Sent by a CLI older than the minimum (Claude Code 2.1.300, Codex 0.162.1), so text and work details weren’t kept.",
  "reason.expired.help": "Deleted automatically after retention (text 30 days, usage and basic info 180 days).",
  "reason.gap.help": "A time when the collection server was down or unreachable.",
  "reason.permission.help": "The value exists, but your role can’t see it.",
  "reason.small_group.help": "Hidden when fewer than 3 people remain, so no one can be singled out. Your own records are never hidden.",
  "reason.verifying.help": "The value exists, but totals from different sources don’t match yet.",
  "partial.truncated": "truncated",
  "partial.estimated_link": "estimated link",
  "partial.estimated": "estimated",
  "partial.unofficial": "unofficial",
  "partial.verifying": "being verified",
  "partial.truncated.help": "The tool only sent part of the value (e.g. Claude Code sends the first 128 characters of each value).",
  "partial.estimated_link.help": "Questions and AI calls were linked by time order, not by an exact id.",
  "partial.estimated.help": "Estimated from shell commands or patches. Not guaranteed to be complete.",
  "partial.unofficial.help": "Not in the official documentation (e.g. Codex answers and self-estimated cost).",
  "partial.verifying.help": "Totals from different sources don’t match yet (e.g. Codex usage).",
  "reasonDetail.codex_active": "Codex doesn’t send AI active time",
  "reasonDetail.claude_reasoning": "Claude doesn’t report thinking separately",
  "reasonDetail.anthropic_reasoning": "Thinking for the Anthropic API is being checked",
  "reasonDetail.codex_loc": "Codex doesn’t send line counts (only patch estimates)",
  "reasonDetail.openai_cache_write": "The OpenAI API doesn’t report cache writes",
  "reasonDetail.codex_cache_write": "Codex cache writes aren’t stacked until we confirm they aren’t already in input",
  "reasonDetail.codex_tokens": "Codex usage: reconciling the CLI summary with recorded totals",
  "reasonDetail.codex_cost": "Codex cost is unofficial and may not arrive",
  "reasonDetail.codex_slash": "Codex doesn’t send slash commands separately",
  "reasonDetail.codex_answers": "Codex answers need an unofficial setting",
  "reasonDetail.api_time": "API key calls have no AI active time",
  "reasonDetail.api_files": "API key calls have no file work",
  "reasonDetail.api_duration": "Chat duration is unknown for API key calls",
  "reasonDetail.metrics_off": "Metrics export is off",
  "card.basis": "Based on {n|record|records}",
  "card.excluded": "{n|record|records} excluded",
  "card.excludedPeople": "{p|person|people} · {n|record|records} excluded",
  "card.cond": "Conditions: {cond}",
  "card.updated": "Updated {time} (Korea time)",
  "card.noRecord": "No record ≠ not used",
  "card.help": "Help: {title}",
  "card.helpTip": "Explain this card",
  "card.onlyThis": "This card only: {v}",
  "card.followCommon": "Follow common filters",
  "card.statsLink": "Details in Insights",
  "card.notMean": "No records doesn’t mean AI wasn’t used.",
  "card.emptyWhat": "No records match these conditions.",
  "card.emptyNext": "Loosen conditions",
  "card.loadError": "Couldn’t load",
  "card.loadErrorDesc": "Try again in a moment.",
  "card.formula": "Formula",
  "card.addView": "Add to saved view",
  "card.export": "Export",
  "kpi.vsBase": "vs {base}",
  "statsItem.prompts": "Questions",
  "statsItem.usage": "Usage",
  "statsItem.files": "Files opened & edited",
  "statsItem.changes": "Changes",
  "statsItem.time": "Time",
  "statsItem.models": "AI models & thinking depth",
  "statsItem.actions": "Actions by AI & errors",
  "statsItem.api": "API & cost",
  "delta.s.up": "{p}% more than {base} ({prev}→{cur})",
  "delta.s.down": "{p}% less than {base} ({prev}→{cur})",
  "delta.s.flat": "About the same as {base} ({prev}→{cur})",
  "delta.s.new": "None in {base} (0→{cur})",
  "delta.base.today": "yesterday",
  "delta.base.day": "the day before",
  "delta.base.days": "the previous {n} days",
  "delta.base.week": "last week",
  "delta.base.prev": "the previous period",
  "delta.chip.up": "▲ {p}%",
  "delta.chip.down": "▼ {p}%",
  "delta.chip.flat": "About same",
  "delta.chip.new": "New",
  "fixed.notEval": "Usage statistics are for cost and security management, never for evaluating work or performance",
  "fixed.activeTime": "Not working hours or a performance measure",
  "fixed.duration": "Not working time",
  "fixed.lines": "Not an AI contribution rate",
  "fixed.cost": "Estimate · not a bill",
  "fixed.orgBill": "Billing basis · daily · not per person",
  "fixed.decision": "Allowed doesn’t mean it ran successfully",
  "person.pseudonymNote": "Shown as a pseudonym because you can’t see real names",
  "term.open": "Explain {term}",
  "term.more": "More in the glossary",
  "term.external": "External explanation",
  "term.lang.ko": "Korean",
  "term.lang.en": "English",
  "term.manual": "The manual section is coming soon",
  "term.linkHidden": "The external link is hidden while it’s being checked",
  "term.plain": "Plain words",
  "term.original": "Original term",
  "term.clickHint": "Click for details",
  "help.button": "Help",
  "help.title": "Help",
  "help.kicker": "How to read this app",
  "help.read.title": "Reading the numbers",
  "help.read.1": "Large numbers are shortened (12K tokens ≈ 12,000 tokens). Hover a shortened number to see the full value.",
  "help.read.2": "Usage adds four non-overlapping kinds (newly read, read from cache, saved to cache, written by AI). Thinking is already included in written by AI.",
  "help.read.3": "Estimated cost is not a bill. Costs calculated differently are never added together.",
  "help.read.4": "Wait time shows “typical” (half finish within it) and “slow” (95 of 100 finish within it).",
  "help.read.5": "Dashed lines in charts are the previous period (same length, right before). CLI tools are solid, API key calls are hatched.",
  "help.empty.title": "Why is it empty?",
  "help.empty.lead": "Empty cells show “No record · reason” instead of 0. No record doesn’t mean AI wasn’t used.",
  "help.source.title": "Where do records come from?",
  "help.source.lead": "Records arrive through six paths, each with different values.",
  "help.source.C1": "Official CLI records",
  "help.source.C1.desc": "Claude Code and Codex on your PC send straight to the company collection server.",
  "help.source.C2": "PC helper",
  "help.source.C2.desc": "Collects on your PC first, then sends (optional module, off for now).",
  "help.source.C3": "API gateway",
  "help.source.C3.desc": "Recorded when apps and scripts call AI through the company gateway.",
  "help.source.C4": "Org reports",
  "help.source.C4.desc": "Daily usage and cost from the AI companies (not per person).",
  "help.source.C5": "This app’s records",
  "help.source.C5.desc": "Sign-ins, permissions, policy, consent and views inside this app.",
  "help.source.C6": "Detailed records",
  "help.source.C6.desc": "More detail from hooks and transcript files (to be decided, off for now).",
  "help.source.on": "On",
  "help.source.off": "Off",
  "help.flow.pc": "AI tool on my PC",
  "help.flow.app": "Apps & scripts",
  "help.flow.server": "Company collection server",
  "help.flow.gateway": "Company gateway",
  "help.flow.vendor": "AI company",
  "help.flow.store": "Storage (masked, encrypted)",
  "help.scope.title": "What I can see",
  "help.scope.lead": "Current role: {role} · view scope {scopes}",
  "help.scope.bundle": "{bundle}: {value}",
  "help.scope.flow": "Other people’s text needs a reason, re-sign-in and a per-conversation grant (60 min).",
  "help.glossary": "Open glossary",
  "help.manual": "The user manual is coming soon",
  "help.coverage": "What gets recorded",
  "access.step.reason": "Reason",
  "access.step.reauth": "Re-sign-in",
  "access.step.grant": "Grant",
  "access.caseLabel": "Approved investigation",
  "access.caseNone": "Enter a reason",
  "access.caseHint": "The approved investigation reason will be used. Reauthentication is still required.",
  "access.caseRequired": "Repeated access to conversations from different people requires an approved investigation.",
  "access.caseManage": "Go to investigations and approvals",
  "access.catLabel": "Reason category",
  "access.catHint": "Evaluation or attendance are not reason categories.",
  "access.reauth.title": "Sign in again to confirm",
  "access.reauth.desc": "Once confirmed, we won’t ask again for 10 minutes. (Mockup: type anything.)",
  "access.reauth.password": "Password",
  "access.reauth.google": "Sign in again with Google",
  "access.reauth.confirm": "Confirm and open",
  "access.reauth.empty": "Please enter your password.",
  "access.denied": "The reason was too short, so access was denied. Denials are logged too.",
  "access.next": "Next",
  "access.watermark": "Viewed by: {role} (user code {code}) · {time}",
  "access.leftClock": "{mmss} left",
  "access.expired": "The grant has ended. Leave a reason again to view.",
  "setup.title": "Initial setup checklist",
  "setup.done": "{n}/{total} done",
  "setup.optional": "Optional",
  "setup.ceiling": "Set the recording ceiling",
  "setup.notice": "Publish the notice",
  "setup.teams": "Create teams and assign managers",
  "setup.invite": "Invite people",
  "setup.connect": "Send connection guides",
  "setup.gateway": "Connect the gateway and org reports",
  "footer.noRecord": "No record ≠ not used",
  "sessionTitle.anon": "Conversation #{no} · {n|question|questions} · {chars} chars",
  "common.close": "Close",
  "common.more": "Show more",
  "common.undo": "Undo",
  "nav.moreCurrent": "Current page: {page}",
  "access.catRequired": "Choose a reason category.",
  "level.name.1": "Basic info",
  "level.name.2": "Question text",
  "level.name.3": "AI answer text",
  "level.name.4": "Work details",
  "card.excludedDeletion": "{n|record|records} excluded (deletion requested)",
  "url.fix.title": "Some conditions in the link were changed",
  "url.fix.scope": "View scope “{want}” isn’t available on this page, so it opened as “{got}”.",
  "url.fix.period": "The period wasn’t valid (366 days max, no future dates), so it opened as “{got}”.",
  "url.fix.method": "The usage method wasn’t valid, so it opened as “All”.",
  "url.fix.team": "That team doesn’t exist, so it opened with all teams.",
  "url.fix.teamSmall": "The team in the link has fewer than 3 people and can’t be chosen (small-group protection). Opened with all teams.",
  "scope.teamSmallBlocked": "Teams with fewer than 3 people can’t be chosen (small-group protection).",
  "support.item.tokens": "Usage (tokens)",
  "reasonShort.consent_before": "Pre-consent",
  "reasonShort.paused": "Paused",
  "reasonShort.level_off": "Level off",
  "reasonShort.cli_not_sent": "CLI off",
  "reasonShort.tool_not_sent": "Not sent",
  "reasonShort.not_applicable": "Not applicable",
  "reasonShort.version_checking": "Checking",
  "reasonShort.old_version": "Old version",
  "reasonShort.expired": "Expired",
  "reasonShort.gap": "Gap",
  "reasonShort.permission": "No access",
  "reasonShort.small_group": "Under 3",
  "reasonShort.verifying": "Verifying",
  "partialShort.truncated": "Truncated",
  "partialShort.estimated_link": "Est. link",
  "partialShort.estimated": "Estimated",
  "partialShort.unofficial": "Unofficial",
  "partialShort.verifying": "Verifying",
  "state.failPill": "Not loaded",
  "state.failTitle": "Something went wrong while getting the records",
  "state.more": "Details",
  "state.errCode": "Error code",
  "common.retryNow": "Retry now",
  "toast.working": "In progress",
  "toast.close": "Dismiss notification",
  "toast.stack": "Notifications in progress",
  "palette.group.recent": "Recent searches",
  "palette.recent.sub": "Search for this again",
  "palette.recent.clear": "Clear recent searches",
  "palette.recent.clearSub": "Kept in this browser only",
  "palette.recent.cleared": "Recent searches cleared",
  "period.limitHint": "Up to 366 days. Dates after today can’t be picked.",
  "period.sum": "{from}–{to} · {n|day|days}",
  "period.err.empty": "Enter both a start and an end date.",
  "period.err.future": "Dates after today ({today}) can’t be picked.",
  "period.err.long": "Pick up to 366 days (now {n}).",
  "empty.connect.title": "No records received yet.",
  "empty.connect.l1": "No records doesn’t mean you didn’t use AI.",
  "empty.connect.l2": "Once you connect a tool, your next question is recorded here.",
  "empty.connect.btn": "Connect tools",
  "bell.newLive": "{n|new notification|new notifications} arrived",
  "chart.avgN": "Avg {v}",
};

export default common;
